import {
  Check,
  CheckCircle,
  ChevronLeft,
  ChevronRight,
  Circle,
  CircleCheck,
  CircleX,
  Eye,
  EyeOff,
  House,
  Info,
  LoaderCircle,
  Lock,
  Menu,
  Minus,
  PlayingCardsFan,
  Plus,
  RefreshCw,
  RotateCcw,
  RotateCw,
  Search,
  Trash2,
  TriangleAlert,
  X,
  MessageCircle,
  Calendar,
} from 'lucide-react';

export const Icons = {
  info: Info,
  x: X,
  checkCircle: CircleCheck,
  search: Search,
  circle: Circle,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  check: Check,
  cards: PlayingCardsFan,
  menu: Menu,
  calendar: Calendar,

  message: MessageCircle,
  refresh: RefreshCw,
  undo: RotateCcw,
  redo: RotateCw,
  trash: Trash2,
  alertTriangle: TriangleAlert,
  lock: Lock,
  plusBold: Plus,
  minusBold: Minus,
  home: House,
  openEye: Eye,
  closeEye: EyeOff,
  loading: LoaderCircle,
  // toast icons
  toastSuccess: CheckCircle,
  toastError: CircleX,
  toastInfo: Info,
  toastWarning: TriangleAlert,
};
